/**
 * Game State Definitions for Street Dice Legends
 *
 * These are shared between client and server to ensure consistency
 */
// ============================================================================
// CEE-LO GAME STATES
// ============================================================================
export var CeeloState;
(function (CeeloState) {
    // Pre-game
    CeeloState["WAITING"] = "waiting";
    CeeloState["STARTING"] = "starting";
    CeeloState["HI_LO"] = "hi_lo";
    // Banker phase
    CeeloState["BANKER_SET_POT"] = "banker_set_pot";
    CeeloState["FADING"] = "fading";
    CeeloState["BANKER_ROLL"] = "banker_roll";
    // Per-shooter phase (repeats for each non-banker player)
    CeeloState["PLAYER_BETTING"] = "player_betting";
    CeeloState["PLAYER_ROLL"] = "player_roll";
    // Resolution
    CeeloState["ROUND_END"] = "round_end";
    CeeloState["GAME_END"] = "game_end";
    // Special
    CeeloState["PAUSED"] = "paused";
})(CeeloState || (CeeloState = {}));
// ============================================================================
// CRAPS GAME STATES
// ============================================================================
export var CrapsState;
(function (CrapsState) {
    // Pre-game
    CrapsState["WAITING"] = "waiting";
    CrapsState["STARTING"] = "starting";
    // Shooter selection (uses shared HI_LO service)
    CrapsState["HI_LO"] = "hi_lo";
    // Pre-come-out
    CrapsState["SHOOTER_SET_STACK"] = "shooter_set_stack";
    CrapsState["FADING"] = "fading";
    // Sidebet phase (interrupt-eligible per locked design)
    CrapsState["SIDEBET_BETTING"] = "sidebet_betting";
    // Come-out roll
    CrapsState["COME_OUT"] = "come_out";
    CrapsState["COME_OUT_RESULT"] = "come_out_result";
    // Point phase
    CrapsState["POINT_ESTABLISHED"] = "point_established";
    CrapsState["POINT_ROLL"] = "point_roll";
    CrapsState["POINT_RESULT"] = "point_result";
    // Resolution
    CrapsState["SHOOTER_WINS"] = "shooter_wins";
    CrapsState["SHOOTER_LOSES"] = "shooter_loses";
    CrapsState["ROUND_END"] = "round_end";
    CrapsState["GAME_END"] = "game_end";
    CrapsState["PAUSED"] = "paused";
    /** @deprecated Use SHOOTER_SET_STACK / FADING / SIDEBET_BETTING. Kept for legacy stub compat; remove when CrapsRoom delegates to StrategyDrivenRoom. */
    CrapsState["BETTING"] = "betting";
})(CrapsState || (CrapsState = {}));
// ============================================================================
// SOLO GRIND GAME STATES (single-player, house-banked)
// ============================================================================
export var SoloState;
(function (SoloState) {
    SoloState["WAITING"] = "solo_waiting";
    SoloState["BETTING"] = "solo_betting";
    SoloState["FADE"] = "solo_fade";
    SoloState["ROLL"] = "solo_roll";
    // Transparent continue beat for the Hi-Lo 7 re-roll (bet stays live, dice
    // stay on the floor). Exists ONLY to break the same-state ROLL→ROLL
    // transition the engine skips — mirrors craps POINT_RESULT.
    SoloState["REROLL"] = "solo_reroll";
    SoloState["GAME_END"] = "solo_game_end";
})(SoloState || (SoloState = {}));
// ============================================================================
// BETTING STATES (Client-side betting)
// ============================================================================
export var BettingState;
(function (BettingState) {
    BettingState["INACTIVE"] = "inactive";
    BettingState["IDLE"] = "idle";
    BettingState["SELECTING_DENOMINATION"] = "selecting_denomination";
    BettingState["DRAGGING_BILL"] = "dragging_bill";
    BettingState["BILL_PLACED"] = "bill_placed";
    BettingState["CONFIRMING"] = "confirming";
})(BettingState || (BettingState = {}));
// ============================================================================
// DICE THROW STATES (Client-side physics)
// ============================================================================
export var DiceThrowState;
(function (DiceThrowState) {
    DiceThrowState["READY"] = "ready";
    DiceThrowState["PICKING_UP"] = "picking_up";
    DiceThrowState["HOLDING"] = "holding";
    DiceThrowState["THROWING"] = "throwing";
    DiceThrowState["ROLLING"] = "rolling";
    DiceThrowState["SETTLING"] = "settling";
    DiceThrowState["STOPPED"] = "stopped";
})(DiceThrowState || (DiceThrowState = {}));
// ============================================================================
// UI / SCREEN STATES
// ============================================================================
export var ScreenState;
(function (ScreenState) {
    ScreenState["LOADING"] = "loading";
    ScreenState["LOGIN"] = "login";
    ScreenState["MAIN_MENU"] = "main_menu";
    ScreenState["LOBBY_BROWSER"] = "lobby_browser";
    ScreenState["MATCHMAKING"] = "matchmaking";
    ScreenState["IN_GAME"] = "in_game";
    ScreenState["POST_GAME"] = "post_game";
    ScreenState["SETTINGS"] = "settings";
    ScreenState["PROFILE"] = "profile";
    ScreenState["CREW"] = "crew";
    ScreenState["SHOP"] = "shop";
    ScreenState["DICE_COLLECTION"] = "dice_collection";
    ScreenState["CHAT"] = "chat";
    ScreenState["LEADERBOARD"] = "leaderboard";
})(ScreenState || (ScreenState = {}));
// ============================================================================
// CONNECTION STATES
// ============================================================================
export var ConnectionState;
(function (ConnectionState) {
    ConnectionState["DISCONNECTED"] = "disconnected";
    ConnectionState["CONNECTING"] = "connecting";
    ConnectionState["AUTHENTICATING"] = "authenticating";
    ConnectionState["CONNECTED"] = "connected";
    ConnectionState["RECONNECTING"] = "reconnecting";
    ConnectionState["ERROR"] = "error";
})(ConnectionState || (ConnectionState = {}));
// ============================================================================
// PLAYER STATES (within a game)
// ============================================================================
export var PlayerState;
(function (PlayerState) {
    PlayerState["SPECTATING"] = "spectating";
    PlayerState["WAITING"] = "waiting";
    PlayerState["BETTING"] = "betting";
    PlayerState["ROLLING"] = "rolling";
    PlayerState["IDLE"] = "idle";
    PlayerState["DISCONNECTED"] = "disconnected";
    PlayerState["LEFT"] = "left";
})(PlayerState || (PlayerState = {}));
export var CeeloResultType;
(function (CeeloResultType) {
    CeeloResultType["ACE"] = "ace";
    CeeloResultType["PAIR"] = "pair";
    CeeloResultType["TRIPS"] = "trips";
    CeeloResultType["TRIPS_6"] = "trips_6";
    CeeloResultType["CEELO"] = "ceelo";
    CeeloResultType["NOTHING"] = "nothing";
})(CeeloResultType || (CeeloResultType = {}));
//# sourceMappingURL=GameStates.js.map